import { axiosInstance } from "./";

// Fetch Satisfaction Survey for an Event
export const fetchSurvey = async (eventId) => {
  return await axiosInstance.get(`/events/${eventId}/satisfaction_surveys`);
};

// Create Survey API
export const createSurvey = (data) => {
  console.log("APIDATA", data);
  let body = data?.data;
  return axiosInstance.post(
    `/events/${data?.event_id}/satisfaction_surveys`,
    body,
    data?.comments
  );
};
